//translation from front-end accessory types to server accessory types
import { AID } from '../enums/AccessoryIdEnum.js';

export const AccessoryTranslation = {

    [AID.HAT]: "head",
    [AID.SHIRT]: "chest",
    [AID.SHOE_LEFT]: "feet",
    [AID.HAND]: "accessory",
    [AID.PANTS]: "legs",

}